import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { HeaderLink } from '../../interfaces';

@Component({
  selector: 'app-social-links',
  templateUrl: './social-links.component.html',
  styleUrls: ['./social-links.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SocialLinksComponent {
  links = input<HeaderLink[]>([]);
}
